import { PageLayout, Section } from "../components/PageLayout";
import { WideOpener, AtmoBreak, SideBySide } from "../components/ImageBlocks";
import { useLanguage } from "../contexts/LanguageContext";

const PAINTING_HERO_URL =
  "https://customer-assets.emergentagent.com/job_clickable-image-nav/artifacts/uqv1i45i_274b732c-0239-4cb3-918c-c24819a89b59.jpeg";

export default function RausAusDemFalschenLeben() {
  const { t } = useLanguage();
  return (
    <PageLayout>
      {/* Hero — neues Aurora-Bild mit Seitentitel im Bild */}
      <WideOpener
        src="raus-hero-aurora_21-9.png"
        alt={t("menuRaus")}
        heading={t("menuRaus")}
      />

      <div
        className="mx-auto w-full max-w-3xl text-[17px] leading-[1.6] sm:text-[18px]"
        style={{ color: "#1A1A1A" }}
        data-testid="page-raus-intro"
      >
        <SideBySide src="IST_aufbruch_q_v01.jpg" alt="">
          <p>{t("raus_intro_1")}</p>
          <p>{t("raus_intro_2")}</p>
          <p>{t("raus_intro_3")}</p>
          <p>{t("raus_intro_4")}</p>
          <p className="border-l-2 pl-5 italic" style={{ borderColor: "#2A2624" }}>
            {t("raus_welcome")}
          </p>
        </SideBySide>
      </div>

      <WideOpener
        src="wide-1-3_umschlag_21-9_v01.jpeg"
        alt={t("raus_11_heading")}
        heading={t("raus_11_heading")}
      />

      <Section testId="section-idee-ursprung">
        <SideBySide src="IST_horizont_q_v01.jpg" alt="">
          <p>{t("raus_11_p1")}</p>
          <p>{t("raus_11_p2")}</p>
          <p>{t("raus_11_p3")}</p>
        </SideBySide>
        <AtmoBreak src="1-1_ursprung_16_v01.jpeg" alt="" />
      </Section>

      <WideOpener
        src="wide-2-3_uebergang_21-9_v01.jpeg"
        alt={t("raus_12_heading")}
        heading={t("raus_12_heading")}
      />

      <Section testId="section-weg">
        <SideBySide src="IST_weg_q_v01.jpg" alt="">
          <p>{t("raus_12_intro")}</p>
          <div>
            <h3 className="text-[22px] sm:text-[24px]" style={{ color: "#1A1A1A", fontWeight: 600 }}>
              {t("raus_12_h1")}
            </h3>
            <p className="mt-2">{t("raus_12_p1")}</p>
          </div>
          <div>
            <h3 className="text-[22px] sm:text-[24px]" style={{ color: "#1A1A1A", fontWeight: 600 }}>
              {t("raus_12_h2")}
            </h3>
            <p className="mt-2">{t("raus_12_p2")}</p>
          </div>
          <div>
            <h3 className="text-[22px] sm:text-[24px]" style={{ color: "#1A1A1A", fontWeight: 600 }}>
              {t("raus_12_h3")}
            </h3>
            <p className="mt-2">{t("raus_12_p3")}</p>
          </div>
        </SideBySide>
        <AtmoBreak src="1-2_weg_16_v01.jpg" alt="" />
        <p className="mt-2 border-l-2 pl-5 italic" style={{ borderColor: "#2A2624" }}>
          {t("raus_12_quote")}
        </p>
      </Section>

      {/* Kapitelöffner Section "Das Gemälde" — das Original-Gemälde (ohne Play-Button) */}
      <WideOpener
        src={PAINTING_HERO_URL}
        folder=""
        alt={t("raus_13_heading")}
        heading={t("raus_13_heading")}
      />

      <Section testId="section-gemaelde">
        <SideBySide src="IST_kreis_q_v01.jpg" alt="">
          <p>
            <strong>{t("raus_13_title_label")}</strong> {t("raus_13_title_value")}
          </p>
          <p>{t("raus_13_p1")}</p>
          <div className="border-l-2 pl-5" style={{ borderColor: "#2A2624" }}>
            <p className="italic">{t("raus_13_artist")}</p>
            <p
              className="mt-3 text-sm"
              style={{ color: "rgba(26,26,26,0.6)", fontWeight: 500 }}
            >
              {t("raus_13_artist_signoff")}
            </p>
          </div>
        </SideBySide>
        <AtmoBreak src="1-3_essenz_16_v01.jpeg" alt="" />
        <p className="mt-2 border-l-2 pl-5 italic" style={{ borderColor: "#2A2624" }}>
          {t("raus_13_quote")}
        </p>
      </Section>
    </PageLayout>
  );
}
